import { useSelector, useDispatch } from "react-redux";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import { UPDATE_FILTER } from "@/redux/types/auth.types";
import { textConstants } from "@/languages/textConstants";
import useFilterStore from "@/stores/useFilterStore";
import classes from "../filter.module.scss";

const FilterCurrency = ({ filter }) => {
	const dispatch = useDispatch();
	const { updateFilter } = useFilterStore();
	const { user } = useSelector((state) => state.auth);

	const handleCurrencyFilter = (value) => {
		const currency = value && user?.customer && textConstants[user.customer.country_id] ? textConstants[user.customer.country_id].currency : "USD";

		const newFilter = { ...filter, type_currency: currency };

		dispatch({ type: UPDATE_FILTER, payload: { filter: newFilter } });
		updateFilter({ type_currency: currency });
	};

	const currencyLabel = user?.customer?.country_id && textConstants[user.customer.country_id] ? textConstants[user.customer.country_id].currency : "USD";

	return (
		<div className={classes.currencySection}>
			<h4>Tipo de moneda</h4>
			<CustomInputSwitch
				value={filter?.type_currency !== "USD"}
				onChange={handleCurrencyFilter}
				optionLeft="USD"
				optionRight={currencyLabel}
				customStyles={{ width: "100%" }}
			/>
		</div>
	);
};

export default FilterCurrency;
